










import { Vue, Component, Ref } from 'vue-property-decorator';

@Component
export default class ScrollLine extends Vue {
    /**
     *
     */
    @Ref()
    public readonly scroller!: HTMLElement;
    /**
     *
     */
    @Ref()
    public readonly box!: HTMLElement;
}
